import React, { useState, useEffect } from 'react';
import API from 'config/ApiConfig';

export default function CreateSiswa() {
  const [formData, setFormData] = useState({
    nama: '',
    ttl: '',
    telepon: '',
    nama_orangtua: '',
    nama_sekolah: '',
    kelas: '',
    alamat: '',
    tentor_id: [], // Array untuk menyimpan ID tentor
    user_id: '',
  });
  const [tentors, setTentors] = useState([]);
  const [users, setUsers] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  const [tentorFields, setTentorFields] = useState([0]); // Track dropdown tentor fields
  const API_BASE_URL = API.API_ADMIN;
  const JWT_TOKEN = localStorage.getItem('authToken');

  function getAuthHeaders() {
    return {
      'Authorization': `Bearer ${JWT_TOKEN}`,
      'Content-Type': 'application/json',
    };
  }

  useEffect(() => {
    const fetchTentors = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/tentor`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setTentors(data);
      } catch (error) {
        console.error('Error fetching tentors:', error);
        setFetchError('Failed to fetch tentors.');
      }
    };

    const fetchUsers = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/user`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error('Error fetching users:', error);
        setFetchError('Failed to fetch users.');
      }
    };

    fetchTentors();
    fetchUsers();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleTentorChange = (index, e) => {
    const { value } = e.target;
    setFormData((prevFormData) => {
      const newTentorIds = [...prevFormData.tentor_id];
      newTentorIds[index] = value;
      return {
        ...prevFormData,
        tentor_id: newTentorIds,
      };
    });
  };

  const handleAddTentorField = () => {
    setTentorFields((prevFields) => [...prevFields, prevFields.length]);
  };

  const handleRemoveTentorField = (index) => {
    setTentorFields((prevFields) => prevFields.filter((_, i) => i !== index));
    setFormData((prevFormData) => {
      const newTentorIds = prevFormData.tentor_id.filter((_, i) => i !== index);
      return {
        ...prevFormData,
        tentor_id: newTentorIds,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API_BASE_URL}/siswa`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      alert('Berhasil Membuat Siswa');
      window.location.href = '/admin/siswa';
    } catch (error) {
      console.error('Error creating siswa:', error);
      setFetchError('Failed to create siswa.');
    }
  };

  return (
    <div>
      <h3 className="font-bold uppercase text-lg text-blueGray-700 align-center m-4">Create Siswa</h3>
      {fetchError && <p className="text-red-500 text-xs">{fetchError}</p>}
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Input fields */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Nama:</label>
          <input
            type="text"
            name="nama"
            value={formData.nama}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Tempat Tanggal Lahir:</label>
          <input
            type="text"
            name="ttl"
            value={formData.ttl}
            onChange={handleChange}
            placeholder="misal Jakarta, 15 Januari 2008"
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Nomor Telepon:</label>
          <input
            type="text"
            name="telepon"
            value={formData.telepon}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Nama Orang Tua:</label>
          <input
            type="text"
            name="nama_orangtua"
            value={formData.nama_orangtua}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Nama Sekolah:</label>
          <input
            type="text"
            name="nama_sekolah"
            value={formData.nama_sekolah}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Kelas:</label>
          <input
            type="text"
            name="kelas"
            value={formData.kelas}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Alamat:</label>
          <input
            type="text"
            name="alamat"
            value={formData.alamat}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>

        {/* Tentor Dropdowns */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Pilih Tentor:</label>
          {tentorFields.map((field, index) => (
            <div key={index} className="mb-2 flex items-center">
              <select
                name={`tentor_id_${index}`}
                value={formData.tentor_id[index] || ''}
                onChange={(e) => handleTentorChange(index, e)}
                className="w-full px-3 py-2 border border-blueGray-300 rounded"
              >
                <option value="">Pilih Tentor</option>
                {tentors.map((tentor) => (
                  <option key={tentor._id} value={tentor._id}>
                    {tentor.nama}
                  </option>
                ))}
              </select>
              {tentorFields.length > 1 && (
                <button
                  type="button"
                  onClick={() => handleRemoveTentorField(index)}
                  className="ml-2 text-red-500"
                >
                  &times;
                </button>
              )}
            </div>
          ))}
          <button
            type="button"
            onClick={handleAddTentorField}
            className="bg-lightBlue-500 text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
          >
            + Tambah Tentor
          </button>
        </div>

        {/* User Dropdown */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Pilih User:</label>
          <select
            name="user_id"
            value={formData.user_id}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          >
            <option value="">Pilih User</option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.username}
              </option>
            ))}
          </select>
        </div>

        <div>
          <button
            type="submit"
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
          >
            Create Siswa
          </button>
          <a href="/admin/siswa">
            <button
              type="button"
              className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            >
              Cancel
            </button>
          </a>
        </div>
      </form>
    </div>
  );
}
